// FIXME: These values are from Google Translate. We need the actual translation from Design team.
export var ErrorVerbiage = {
    Retriable: 'ไม่สามารถดำเนินการชำระเงินได้ โปรดตรวจสอบข้อมูลบัตรของคุณแล้วลองอีกครั้ง',
    NonRetriable: 'ไม่สามารถดำเนินการชำระเงินได้ โปรดป้อนวิธีการชำระเงินอื่นแล้วลองอีกครั้ง',
    SystemError: 'ไม่สามารถดำเนินการชำระเงินได้ กรุณาลองอีกครั้ง.'
};
